import { View } from "binder"
import { ProducerManipulationViewModel, Producer } from "./producerManipulation-viewModel"
import { ServerSideDataLoader } from "uicomponents";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";

export class ProducerManipulationView extends View<ProducerManipulationViewModel> {
    GetViewUniqueId(): string {
        return "V-340371D0-1A71-4D00-8EED-7E56C9C45EE7"
    }
    loadHtml(): string {
        let element = require('./producerManipulation.html').default;
        let style = require('./producerManipulation.less');
        return element;
    }
    constructor() {
        super();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set producers(v: Producer) { this._producers = v; } public get producers(): Producer { return this._producers; } private _producers: Producer;
    public set dataLoader(v: ServerSideDataLoader) { this._dataLoader = v; } public get dataLoader(): ServerSideDataLoader { return this._dataLoader; } private _dataLoader: ServerSideDataLoader;

    public set isShowingPopup(v: boolean) { this._isShowingPopup = v; } public get isShowingPopup(): boolean { return this._isShowingPopup; } private _isShowingPopup: boolean;
    public set popup(v: IPopup) { this._popup = v; } public get popup(): IPopup { return this._popup; } private _popup: IPopup;

    addNew() {
        this.dataContext.addNew();
    }
}
